import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import backButton from "./Images/back.png";

export default function ValveCalculation() {
    const [formData, setFormData] = useState({ flow_rate: '', pressure_drop: '', fluid_type: 'water' });
    const [result, setResult] = useState(null);
    const userEmail = sessionStorage.getItem("userEmail");
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
    if (!userEmail) {
      navigate("/signin");
    }
  }, [userEmail, navigate]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        try {
            const response = await fetch('https://www.d-rosa.ai/vcalculate', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });
            const data = await response.json();
            if (response.ok) {
                setResult(data);
            } else {
                setError(data.error);
            }
        } catch (err) {
            setError('Failed to fetch data');
        }
    };

    return (
        <div className="p-4 max-w-md mx-auto">
            <center>
            <h2 className="text-xl font-bold mb-4">Valve Selection</h2>
            </center>
            <p>Signed in as: {userEmail}</p>
            <form onSubmit={handleSubmit} className="space-y-4">
                <input 
                    type="number" 
                    name="flow_rate" 
                    value={formData.flow_rate} 
                    onChange={handleChange} 
                    placeholder="Flow Rate (GPM)"
                    className="w-full p-2 border rounded"
                    required
                />
                <br /><br />
                <input 
                    type="number" 
                    name="pressure_drop" 
                    value={formData.pressure_drop} 
                    onChange={handleChange} 
                    placeholder="Pressure Drop (psi)"
                    className="w-full p-2 border rounded"
                    required
                />
                <br /><br />
                <select name="fluid_type" value={formData.fluid_type} onChange={handleChange} className="w-full p-2 border rounded">
                    <option value="water">Water</option>
                    <option value="oil">Oil</option>
                    <option value="gas">Gas</option>
                </select>
                <br /><br />
                <button type="submit" className="w-full p-2 bg-blue-500 text-white rounded">Calculate</button>
            </form>
            {result && (
                <div className="mt-4 p-4 border rounded bg-gray-100">
                    <p><strong>Required Cv:</strong> {result.cv}</p>
                    <p><strong>Suggested Valve Type:</strong> {result.valve_type}</p>
                </div>
            )}
            {error && <p className="text-red-500 mt-4">{error}</p>}

           <br /><br />

      <button onClick={() => navigate("/previous-page")}>
        <img src={backButton} alt="Back" width="60" height="60" />
      </button>
      <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />

      <footer className="footer-section">
        <div className="text-6">
          &copy; 2022 HYDAX Hydraulics Pvt. Ltd. All rights reserved.
        </div>
      </footer>
   
        </div>
    );
}
